import React from 'react';
import { connect } from 'react-redux';
import HeaderSmall from '../Components/Header/HeaderSmall';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import { Card, CardActions, CardText } from 'material-ui/Card';
import TabStrip from '../Components/TabStrip';
import moment from 'moment';
import StepGauge from '../Components/ActivityTracker/StepGauge';
import StepSpline from '../Components/ActivityTracker/StepSpline';
import { resourceApi } from '../utils/fetchUtil';
import Spinner from './../Components/Spinner';
import { Dialog } from 'material-ui';
import { hashHistory } from 'react-router';
import HealthPluginUnavailable from './../Components/ActivityTracker/HealthPluginUnavailable'
import  StepColumns from './../Components/ActivityTracker/StepColumns';
import CurrentGoalSummary from './../Components/ActivityTracker/CurrentGoalSummary';
import HealthPermissionsExplanation from '../Components/ActivityTracker/HealthPermissionsExplanation';
import GoogleFitRequired from '../Components/ActivityTracker/GoogleFitRequired';
import IOSPreviousDecline from '../Components/ActivityTracker/IOSPreviousDecline';
import StepTrackerError from '../Components/ActivityTracker/StepTrackerError';
import AchievementCard from '../Components/ActivityTracker/AchievementCard';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { logActivityTracker } from '../actions/logActions';


class ActivityPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            permissions: undefined,

            //full data range determined from the relevant first available achievement to allow backfilling
            startDate: undefined,
            endDate: undefined,

            //we use this bit field to track part of the ios auth process
            promptAuthRequested:false,

            //trailing values for the charts
            trailingWeekSum:undefined,
            trailingMonthSum: undefined,
            trailingWeekData:undefined,
            trailingMonthData:undefined,

            //controls what screen to show user through the authorization process
            viewId:0,

            //while we process the list of achievements we will use these to determine the ranges we need to sum for the top troph values
            //they hold the full achievementVM
            currentDayAchievement:undefined,
            currentWeekAchievement:undefined,
            currentMonthAchievement:undefined,

            //current values for the currentWeekAchievement datapoints for appropriate date range.
            currentDayAchievementValue:undefined,
            currentWeekAchievementValue:undefined,
            currentMonthAchievementValue:undefined,

            //historical achievement counts
            dailyAchievementCount:0,
            weeklyAchievementCount:0,
            monthlyAchievementCount:0

        }
    }

    componentDidMount() {
        logActivityTracker('view');
        this.getAchievements();
        this.getAchievementSummaries();
    }

    debugOutput(){
        //console.log("Stepper Debug:",arguments);
    }

    permissions = () => {
        if(this.getPlatform() === 'android'){
            return [{read:['steps']}]
        }
        return [{read:['steps'], write:['steps']}]
    }

    //API Calls

    getAchievementSummaries(){
        resourceApi({method:'get',url:'member/achievements/summaries'})
        .then(res =>{

            if(Array.isArray(res.data)){
                const dailies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 1 ? b['Count'] : 0), 0)
                const weeklies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 2 ? b['Count'] : 0), 0)
                const monthlies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 3 ? b['Count'] : 0), 0)
    
                this.setState({dailyAchievementCount:dailies, weeklyAchievementCount:weeklies, monthlyAchievementCount:monthlies})
            }
            else {
                this.debugOutput('wasnt an array')
                this.setState({dailyAchievementCount:0, weeklyAchievementCount:0, monthlyAchievementCount:0})
            }              

        })
        .catch(err => this.debugOutput(err))

    }
    getAchievements(){
        let config = {
            method:'get',
            url:'member/achievements'
        }

        resourceApi(config)
        .then(res => {
            let ach = res.data;
            if(Array.isArray(ach)){
                let todaysGoal = ach.find(a => a.HealthActivityIntervalID === 1 && new Date(a.StartDate) < new Date() && new Date(a.EndDate) > new Date());
                let weeksGoal = ach.find(a => a.HealthActivityIntervalID === 2 && new Date(a.StartDate) < new Date() && new Date(a.EndDate) > new Date());
                let monthsGoal = ach.find(a => a.HealthActivityIntervalID === 3 && new Date(a.StartDate) < new Date() && new Date(a.EndDate) > new Date());

                this.debugOutput("Achievements", todaysGoal, weeksGoal,monthsGoal)
                this.setState({
                    currentDayAchievement:todaysGoal?todaysGoal:{Name:"Daily Step Goal", Value:5000},
                    currentWeekAchievement:weeksGoal?weeksGoal:{Name:"Weekly Step Goal", Value:30000, StartDate: this.getLastSunday(), EndDate: this.getNextSunday() },
                    currentMonthAchievement:monthsGoal?monthsGoal:{Name:"Monthly Step Goal", Value:120000, StartDate: this.getFirstOfMonth(), EndDate: this.getLastOfMonth()},
                    achievements:ach,
                    startDate:this.getRelevantStartDate(ach)
                }, ()=>{
                    this.debugOutput("Achievements after setState", this.state.startDate, this.state.currentDayAchievement, this.state.currentWeekAchievement, this.state.currentMonthAchievement);
                    this.checkAvailable();
                })
            }
            else {
                this.setState({}, ()=>{this.checkAvailable()})
            }

    })
    .catch((err)=>{
        this.setState({})
    })
    }

    submitAchievements = (data) => {
        if(Array.isArray(data)){
            let config = {
                url: 'member/achievements',
                method: 'post',
                data: data
            }
    
            this.debugOutput("Submitting Achievement(s):", data.length)
    
            resourceApi(config)
            .then(res => {
                if(Array.isArray(res.data)){
                    const dailies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 1 ? b['Count'] : 0), 0)
                    const weeklies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 2 ? b['Count'] : 0), 0)
                    const monthlies = res.data.reduce((a, b) => a + (b['HealthActivityIntervalID'] === 3 ? b['Count'] : 0), 0)

                    this.setState({dailyAchievementCount:dailies, weeklyAchievementCount:weeklies, monthlyAchievementCount:monthlies})

                }
            })
            .catch(err => this.debugOutput(err));
        }
        else {
            this.debugOutput("submitAchievements was not provided a data array.")
        }
    }

    getRelevantStartDate = (achievements) => {
        let filteredAchievements = achievements.filter(ach => new Date(ach.StartDate) <= new Date() && new Date(ach.ExpirationDate) > new Date() && ach.CompletedDate === null);
        let thirtyDaysAgo = new Date() - this.daysToMilliseconds(31);

        if(filteredAchievements.length > 0){
            filteredAchievements.sort((a,b) => a.StartDate < b.StartDate ? -1 : 1)
            this.debugOutput('Start Date:', filteredAchievements[0].StartDate)
            let startDate = new Date(filteredAchievements[0].StartDate);
            return startDate < thirtyDaysAgo ? startDate : thirtyDaysAgo;
        }

        return thirtyDaysAgo;

    }

    daysToMilliseconds = (days) => {
        //days*hours*minutes*seconds*miliseconds
        return days * 24 * 60 * 60 * 1000
    }

    getPlatform = () => {
        if(window.device){
            return window.device.platform.toLowerCase();
        }
        else if(window.cordova && window.cordova.platformId){
            return window.cordova.platformId.toLowerCase();
        }
        else {
            return 'pc'
        }
    }

    checkAvailable = () => {
        this.debugOutput('Checking Availability')
        if (window.navigator && window.navigator.health) {
            window.navigator.health.isAvailable(this.successIsAvailable, this.errorIsAvailable)
        }
        else {
            this.debugOutput('Plugin Not Available')
            if(this.getPlatform() === 'pc'){
                //test environment
                let fakeData = [];
                for(let i = 0; i <= 30; i++){
                    fakeData.push({ActivityDate:new Date()-this.daysToMilliseconds(30-i), Value: 4286.123456789})
                }
                this.setState({
                    trailingMonthData:fakeData.slice(0,30), 
                    trailingWeekData:fakeData.slice(-7),
                    trailingMonthSum:fakeData.slice(0,30).reduce((a, b) => a + (b['Value'] || 0), 0),
                    trailingWeekSum:fakeData.slice(-7).reduce((a, b) => a + (b['Value'] || 0), 0),
                    currentDayAchievementValue:fakeData[fakeData.length-1].Value,
                    currentMonthAchievementValue:fakeData.slice(0,30).reduce((a, b) => a + (b['Value'] || 0), 0),
                    currentWeekAchievementValue:fakeData.slice(-7).reduce((a, b) => a + (b['Value'] || 0), 0),
                }, ()=>{
                    this.debugOutput("Calling Achievements Processing")
                    this.setState({viewId:6})
                    this.processAchievements(fakeData)
                })
            } else {
                //plugin is not present in the shell, show update screen.
                this.debugOutput("Plugin Not Available")
                this.setState({viewId:1});
            }
        }
    }

    successIsAvailable = (v) => {

        if (v === false && this.getPlatform() === "android") {
            this.setState({viewId:3});
            return;
        }
        this.checkAuthorization();
        
    }

    checkAuthorization = () => {
        window.navigator.health.isAuthorized(this.permissions(), this.isAuthorizedSuccess, this.isAuthorizedError)
    }

    isAuthorizedSuccess = (v) => {
        this.debugOutput('isAuthorizedSuccess', v)
        if(v === true){
            this.debugOutput("Authorization Already Given");
            //since authorization was already detected there should be no notification ont he users end that this is occuring.
            //However documentation suggests calling the requestAuthorization method every time regardless of pre-existing authorization
            window.navigator.health.requestAuthorization(this.permissions(), ()=>{this.successAuthorization(v)}, this.errorAuthorization);
        }
        else if(v === false){
            this.debugOutput("No Authorization, Prompting")
            if(this.state.promptAuthRequested && this.getPlatform() === 'ios'){
                this.showIOSPreviouslyDeclinedDialog();
                return;
            }
            //we detected at this point that either authorization is not granted, either being an initial launch or a member decliend previously granted authorization
            //in either event, this is where we will educate the user on what we are about to ask them fore prior to prompting them with the request for permissions.
            //or in the case of an iOS user to let them know they need to provide access via settings
            this.showExplanationDialog();
        }
    }

    showExplanationDialog = () => {
        this.setState({viewId:4});
    }

    isAuthorizedError = (e) => {
        this.debugOutput(e);
    }

    errorIsAvailable = (e) => {
        this.debugOutput('Availability Check Failed: ',e);
        this.setState({viewId:2})
    }

    successAuthorization = (v) => {
        this.debugOutput("successAuthorization Function", v)
        if(v === true){
            this.debugOutput('Authorization Success', v)            
            this.setState({ permissions: true }, ()=>{this.getStepsFromDevice()})
        }
    }

    errorAuthorization = (e) => {
        this.debugOutput('Authorization Failed: ',e)
        this.setState({ permissions: false, viewId:2})
    }

    getLastSunday = () => {
        let t = new Date();
        t.setDate(t.getDate() - t.getDay());
        return t;
    }

    getNextSunday = () => {
        let t = new Date()
        t.setDate(t.getDate() + (7-t.getDay())%7);
        return t;
    }

    getFirstOfMonth = () => {
        var t = new Date();
        return new Date(t.getFullYear(), t.getMonth(), 1);
    }
    
    getLastOfMonth = () => {
        let t = new Date();
        return new Date(t.getFullYear(), t.getMonth() + 1, 0);
    }

    getStepsFromDevice = async () => {

        let startDate = this.state.startDate === undefined  ? (new Date() - this.daysToMilliseconds(31)) : this.state.startDate

        this.debugOutput('Attempting Get Steps Data Since', startDate)

        if (this.state.permissions === true) {           

            //full data set, we'll use this to parce for achievements and set full months data.
            await window.navigator.health.queryAggregated({
                startDate: new Date(startDate),
                endDate: new Date(), // now
                dataType: 'steps',
                bucket:'day',
                limit: 10000
            }, this.successGetSteps, this.errorGetSteps)

            await window.navigator.health.queryAggregated({
                startDate: new Date(this.state.currentWeekAchievement.StartDate),
                endDate: new Date(this.state.currentWeekAchievement.EndDate), // inclusive??? May need to add a millisecond
                dataType: 'steps',
                bucket:'day',
                limit: 10000
            }, (v)=>{ 
                this.debugOutput("Current Weeks Data", v)
                const dasData = this.processSteps(v);
                this.setState({currentWeekAchievementValue:dasData.reduce((a, b) => a + (b['Value'] || 0), 0)})
            }, this.errorGetSteps)

            await window.navigator.health.queryAggregated({
                startDate: new Date(this.state.currentMonthAchievement.StartDate),
                endDate: new Date(this.state.currentMonthAchievement.EndDate), // inclusive??? May need to add a millisecond
                dataType: 'steps',
                bucket:'day',
                limit: 10000
            }, (v)=>{ 
                this.debugOutput("Current Months Data", v)
                const dasData = this.processSteps(v);
                this.setState({currentMonthAchievementValue:dasData.reduce((a, b) => a + (b['Value'] || 0), 0)})
            }, this.errorGetSteps)


            //trailing seven day values, we'll use this for the history chart.
            await window.navigator.health.queryAggregated({
                startDate: new Date(new Date() - this.daysToMilliseconds(6)),
                endDate: new Date(), // now
                dataType: 'steps',
                bucket:'day',
                limit: 10000
            }, (v)=>{ 
                const dasData = this.processSteps(v);
                this.setState({trailingWeekData:dasData, trailingWeekSum:dasData.reduce((a, b) => a + (b['Value'] || 0), 0)})
            }, this.errorGetSteps)


            //trailing month for the history chart
            await window.navigator.health.queryAggregated({
                startDate: new Date(new Date() - this.daysToMilliseconds(30)),
                endDate: new Date(), // now
                dataType: 'steps',
                bucket:'day',
                limit: 10000
            }, (v)=>{
                const dasData = this.processSteps(v);
                this.setState({trailingMonthData:dasData, trailingMonthSum:dasData.reduce((a, b) => a + (b['Value'] || 0), 0)}, ()=>{ this.debugOutput("The State:", this.state)})}, this.errorGetSteps)  
                
                this.setState({viewId:6});
        }

    }

    processSteps = (a) => {
        let processedArray = [];
        if (Array.isArray(a)) {
            a.map((v, i) => {
                processedArray.push({ ActivityDate: v.startDate, Value: v.value });
            })            
        }
        else {
            this.debugOutput("Error, no array recieved")
        }
        return processedArray;
    }

    successGetSteps = (v) => {
        this.debugOutput("Successfully Got Steps")
        if (Array.isArray(v)) {
            let sumArray = [];

            //unsure if this sorting is necessary, suspect the devices api already provides them in order,
            let sortedArray = v.sort((a, b) => a.startDate < b.startDate ? -1 : 1)

            //simplifying the object for our needs
            sortedArray.map((v, i) => {
                sumArray.push({ ActivityDate: v.startDate, Value: v.value });
                if(i === sortedArray.length - 1){
                    sumArray
                }
            })

            this.setState({ 
                currentDayAchievementValue: sumArray[sumArray.length - 1].Value, 
                stepsForSpline: sumArray.slice(0,31), 
                steps:sumArray
            }, ()=>{this.processAchievements(sumArray)})
        }

        
    }

    processAchievements = (stepsArray) => {

        this.debugOutput('Processing Achievements:', stepsArray)

        //empty array to populate with achievements
        let completedAchievements = [];

        //We can be confident that the fetch api has finished by the time this calls since it is initiated by a callback
        //in the original api call setState.
        if(Array.isArray(this.state.achievements) && Array.isArray(stepsArray)){
            for(let i = 0; i < this.state.achievements.length; i++){
                
                if(new Date(this.state.achievements[i].ExpirationDate) > new Date() && this.state.achievements[i].CompletedDate === null){
                    //all activities come in an array of { ActivityDate, Value }
                    //The Activity Date returned by the healthkit api is a DateTime set to 12AM
                    let result = stepsArray.reduce((accumulator, currentValue) => {
                        if(new Date(currentValue.ActivityDate) >= new Date(this.state.achievements[i].StartDate) && new Date(currentValue.ActivityDate) < new Date(this.state.achievements[i].EndDate)){
                            return (parseInt(accumulator) + parseInt(currentValue.Value))
                        }
                        else {
                            return parseInt(accumulator)
                        }
                    }, 0)

                    if(result > this.state.achievements[i].Value){
                        completedAchievements.push(this.state.achievements[i]);
                    }

                }

            }
            this.debugOutput(completedAchievements);
            if(Array.isArray(completedAchievements) && completedAchievements.length > 0){

                this.submitAchievements(completedAchievements);
            }
        }

    }

    errorGetSteps = (e) => {
        this.debugOutput(`Failed Get Steps: ${e}`)
        this.setState({viewId:2});
    }

    showInstallDialog(){
        this.setState({showInstallDialog: true})
    }

    showIOSPreviouslyDeclinedDialog = () => {
        this.setState({viewId:5});
    }

    explanationButton = () => {
        if(this.getPlatform() === 'android'){
            return <div style={{width:'100%'}}><div style={{width:200, margin:'0 auto'}}className={'sign-in-with-google'} onClick={()=>{this.setState({viewId:0, promptAuthRequested:true}, ()=>{window.navigator.health.requestAuthorization(this.permissions(), this.checkAuthorization, this.errorAuthorization)})}}>&nbsp;</div></div>
        }
        return (<button className={'button-style'} style={{backgroundColor:getMuiTheme(window.muiTheme).palette.primary1Color}} onClick={()=>{this.setState({viewId:0, promptAuthRequested:true}, ()=>{window.navigator.health.requestAuthorization(this.permissions(), this.checkAuthorization, this.errorAuthorization)})}}><label>Activate Step Counter</label></button>);
    }

    render() {
        
        const { 
            trailingWeekData, 
            trailingMonthData, 
            currentDayAchievementValue, 
            trailingMonthSum,
            trailingWeekSum,
            currentDayAchievement,
            currentMonthAchievement,
            currentMonthAchievementValue,
            currentWeekAchievement,
            currentWeekAchievementValue,
            dailyAchievementCount,
            weeklyAchievementCount,
            monthlyAchievementCount,
            viewId  
        } = this.state;

        const primary = getMuiTheme(window.muiTheme).palette.primary1Color;

        const installButton = (<button className={'button-style'} style={{backgroundColor:primary}} onClick={()=>{this.setState({viewId: 0}, ()=>{window.navigator.health.promptInstallFit(() => {})})}}><label>Open Play Store</label></button>);

        const explanationButton = this.explanationButton();

        return (
            <div style={{backgroundColor:(viewId !== 6 ? '#fff' : 'inherit'), marginTop:-15, minHeight:'100vh'}}>
                <HeaderSmall title="Step Counter" />
                {viewId === 0 && (
                    <Spinner />
                )}
                {viewId === 1 && (
                    <HealthPluginUnavailable />
                )}
                {viewId === 2 && (
                    <StepTrackerError />
                )}
                {viewId === 3 && (
                    <GoogleFitRequired button={installButton} />
                )}
                {viewId === 4 && (
                    <HealthPermissionsExplanation button={explanationButton}/>
                )}
                {viewId === 5 && (
                    //iOS Previously Disabled Screen
                    <IOSPreviousDecline />
                )}
                {viewId === 6 && (
                <div id={'activity-tracker'} className="container">
                <div id={'activity-tracker-header-container'}>
                    <span className={'activity-tracker-header grey-font'}>Step Goals</span>
                </div>
                    { currentDayAchievementValue !== undefined && trailingWeekData !== undefined && trailingMonthData !== undefined && (
                        <div>
                            <CurrentGoalSummary 
                                dayGoal={currentDayAchievement.Value} 
                                dayValue={Math.round(currentDayAchievementValue)} 
                                weekGoal={currentWeekAchievement.Value}
                                weekValue={Math.round(currentWeekAchievementValue)}
                                monthGoal={currentMonthAchievement.Value}
                                monthValue={Math.round(currentMonthAchievementValue)}
                            />
                            <div id={'chart1'} className={'chart'}>
                                <StepGauge goal={currentDayAchievement.Value} steps={Math.round(currentDayAchievementValue)} />
                            </div>
                            <div id={'chart2'} className={'chart'}>
                                <StepColumns week={trailingWeekData} month={trailingMonthData} goal={currentDayAchievement.Value} />
                            </div>
                            <br />
                            <br />
                            <div>
                                <AchievementCard 
                                    name={currentDayAchievement.Name}
                                    value={currentDayAchievementValue}
                                    goal={currentDayAchievement.Value}
                                    count={dailyAchievementCount}
                                    color={'red'} 
                                    bartext={"Today's Steps"}
                                />
                            </div>
                            <div>
                                <AchievementCard 
                                    name={currentWeekAchievement.Name}
                                    value={currentWeekAchievementValue}
                                    goal={currentWeekAchievement.Value}
                                    count={weeklyAchievementCount}
                                    color={'green'} 
                                    bartext={"Week's Steps"}

                                />
                            </div>
                            <div>
                                <AchievementCard 
                                    name={currentMonthAchievement.Name}
                                    value={currentMonthAchievementValue}
                                    goal={currentMonthAchievement.Value}
                                    count={monthlyAchievementCount}
                                    bartext={"Month's Steps"}
                                    color={'blue'}
                                />
                            </div>
                        </div>
                    )}
                <br />
                <br />
                <br />
                </div>
                )}
            <TabStrip activeTab={29} />
            </div>
        )
    }
}

export default ActivityPage;


// WEBPACK FOOTER //
// ./src/Pages/Activity.js